<template>
    <section :id="`${id}linsDrfTable`" class="no-margin" :style="{'width': '100%', 'height': '100%', 'min-height': '100%'}">
        <!-- <q-window-resize-observable @resize="$_onResize" /> -->
        <div class="q-lins-drftable-container no-border no-padding no-margin">
            <div
                ref="htmlTable"
                class="c-lins-table-container q-table-container"
                :class="{'font-mobile': isMobile}"
            >
                <table
                    class="c-lins-table q-table q-table-horizontal-separator striped-odd bordered highlight"
                    :class="{'responsive': this.lowResolution}"
                >
                    <thead>
                        <tr>
                            <th
                                class="c-table-col c-lins-table-font c-lins-table-col-select th-select"
                                v-show="(selection !== '') && (selection != 'summaryAll')"
                            >
                                <q-checkbox :id="id + 'ChkClear'"
                                    class="c-check-header"
                                    v-model="clear"
                                    v-show="clear && !selectAll"
                                    checked-icon="clear"
                                >
                                    <q-tooltip
                                        anchor="top right"
                                        self="bottom left"
                                    >
                                        {{ $_getHintClear }}
                                    </q-tooltip>
                                </q-checkbox>
                                <q-checkbox :id="id + 'ChkSelectAll'"
                                    class="c-check-header"
                                    v-model="allSelected"
                                    v-show="selectAll && data.length > 0"
                                >
                                    <q-tooltip
                                        anchor="top right"
                                        self="bottom left"
                                    >
                                        {{allSelected ? 'Limpar selecionados' : 'Selecionar todos'}}
                                    </q-tooltip>
                                </q-checkbox>
                            </th>
                            <th
                                class="c-table-col c-lins-table-font c-lins-table-col-expand th-expand"
                                v-show="expand"
                            />
                            <th :id="id + 'Header'+ columns.indexOf(col)"
                                v-for="col in columns"
                                :key="col.index"
                                class="c-table-col c-lins-table-font cursor-pointer"
                                :class="$_formatHeaderClass(col)"
                                :style="{
                                    'min-width': columns.length > 1 ? $_getColWidth(col) : '100%',
                                    'max-width': $_getColWidth(col, col.maxWidth),
                                    'width': columns.length > 1 ? $_getColWidth(col) : '99999px'
                                }"
                                @click="$_sortBy(col)"
                            >
                                <div
                                    class="row no-wrap no-border no-margin no-padding"
                                    :class="'justify-' + $_getColAlign(col)"
                                >
                                    <i
                                        aria-hidden="true"
                                        class="cursor-pointer q-icon material-icons"
                                        v-if="col.sort"
                                    >
                                        {{$_getIconSort(col)}}
                                    </i>
                                    <span class="c-col-label c-lins-table-font">
                                        {{col.label}}
                                    </span>
                                    <q-tooltip
                                        anchor="top left"
                                        self="bottom left"
                                    >
                                        {{col.hint ? col.hint : col.label}}
                                    </q-tooltip>
                                </div>
                            </th>
                            <th
                                class="c-table-col c-lins-table-font c-lins-table-col-expand th-expand"
                                v-show="showCopyButton"
                            />
                        </tr>
                    </thead>
                    <th
                        class="q-lins-drf-table-message flex-center"
                        v-show="!data || data.length === 0"
                        :colspan="columns.length +1"
                    >
                        <i class="material-icons q-icon">warning</i> Nenhuma informação disponível para exibição.
                    </th>
                    <tbody
                        :style="{
                            'height': this.maxHeight ? this.maxHeight : '',
                            'max-height': this.maxHeight ? this.maxHeight : '',
                            'overflow-y': this.maxHeight ? 'auto' : 'hidden'
                        }"
                    >
                        <template v-for="row in data" :key="row.index">
                            <tr
                            class="c-lins-table-row"
                            >
                                <td class="c-lins-table-col-select"
                                    :class="data.indexOf(row) % 2 ? 'c-row-zebra' : ''"
                                    v-show="selection !== ''"
                                >
                                    <q-checkbox :id="id + 'Checkbox' + data.indexOf(row)"
                                        ref="tableChecks"
                                        v-model="selectedRows"
                                        v-show="'multiple summary'.match(selection)"
                                        :disable="!$_doSelectableRow(row)"
                                        :val="row[keyField ? keyField : 'id']"
                                        class="c-table-checkbox"
                                        @input="$_clickCheckBox(row)"
                                    >
                                        <q-tooltip
                                            v-if="disableSelectMsg && !$_doSelectableRow(row)"
                                            anchor="top left"
                                            self="bottom left"
                                        >
                                            {{ disableSelectMsg }}
                                        </q-tooltip>
                                    </q-checkbox>
                                    <q-radio :id="id + 'Radio' + data.indexOf(row)"
                                        ref="tableRadios"
                                        v-model="selectedRow"
                                        v-show="selection === 'single'"
                                        :disable="!$_doSelectableRow(row)"
                                        :val="row[keyField ? keyField : 'id']"
                                    />
                                </td>
                                <td class="c-lins-table-col-expand"
                                    :class="data.indexOf(row) % 2 ? 'c-row-zebra' : ''"
                                    v-show="expand"
                                >
                                    <q-checkbox :id="`${id} CheckExpand ${data.indexOf(row)}`"
                                        class="q-mr-md"
                                        v-model="row.expand"
                                        checked-icon="remove"
                                        unchecked-icon="add"
                                        indeterminate-icon="add"
                                        keep-color
                                        @input="$_onExpandClick(row)"
                                    />
                                </td>
                                <td :id="id + 'Cell'+ columns.indexOf(col) + '_' + data.indexOf(row)"
                                    v-for="col in columns"
                                    :key="col.index"
                                    class="c-table-cell cursor-pointer"
                                    :class="data.indexOf(row) % 2 ? 'c-row-zebra' : ''"
                                    :data-th="col.label"
                                    :style="{
                                        'min-width': columns.length > 1 ? $_getColWidth(col) : '100%',
                                        'max-width': $_getColWidth(col, col.maxWidth),
                                        'width': columns.length > 1 ? $_getColWidth(col) : '99999px',
                                        'text-align': $_getColAlign(col)
                                    }"
                                    @click="$_doCellClick(row, col, $refs.tableChecks)"
                                    @dblclick="$_doCellDblClick(row, col)"
                                >
                                    <span class="c-cell-content"
                                        :class="$_formatCellClass(row, col)"
                                        v-html="$_doFormatValue(row, col, col.field)"
                                    />
                                </td>
                                <td class="c-lins-table-col-copy"
                                    :class="data.indexOf(row) % 2 ? 'c-row-zebra' : ''"
                                    v-show="showCopyButton"
                                >
                                    
                                    <q-btn
                                        :id="`${id} Copy ${data.indexOf(row)}`"
                                        flat
                                        icon="content_copy"
                                        class="no-margin no-padding"
                                        @click="$_copyCellData(row)"
                                    >
                                    <q-tooltip>
                                        {{ copyMessage }}
                                    </q-tooltip>
                                    </q-btn>
                                </td>
                            </tr>
                            <q-tr :id="`${id} RowExpand ${data.indexOf(row)}`"
                                v-show="row.expand"
                                class="c-lins-table-row"
                                style="min-height: 100%; height: 100%"
                            >
                                <q-td
                                    colspan="100%"
                                    style="min-height: 100%; height: 100%"
                                    class="c-lins-table-row-expand"
                                >
                                    <slot
                                        name="expand"
                                        :row="row"
                                    />
                                </q-td>
                            </q-tr>
                        </template>
                    </tbody>
                    <tfoot v-show="showSummary">
                        <tr>
                            <td
                                class="c-table-col c-lins-table-font c-lins-table-col-select th-select"
                                v-show="selection!==''"
                            />
                            <td
                                v-for="col in columns"
                                :id="'s-' + col.label"
                                :key="col.index"
                                class="c-table-cell c-table-summary c-lins-table-font"
                                :class="$_formatSummaryClass(col, columns.indexOf(col) === 0 ? '' : $_doGetSummary(col))"
                                :data-th="col.summary ? col.label : ''"
                                :style="{
                                    'min-width': columns.length > 1 ? $_getColWidth(col) : '100%',
                                    'max-width': $_getColWidth(col, col.maxWidth),
                                    'width': columns.length > 1 ? $_getColWidth(col) : '99999px',
                                    'text-align': $_getColAlign(col)
                                }"
                            >
                                {{columns.indexOf(col) === 0 ? (summaryLabel ? summaryLabel : 'Total'): $_doGetSummary(col)}}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div
                v-if="pagination"
                class="c-pagination-container row no-padding justify-between items-center"
            >
                <div class="col-5 justify-around ">
                    <span v-if="showRecordCount">Total de registros: {{ totalRows }} </span>
                </div>
                <div class="row justify-end">
                    <q-select
                        v-model="perPage"
                        class="c-lins-table-sel-pagination"
                        :options="pageSizesOptions"
                    />
                    <q-pagination
                        v-model="page"
                        class="pagination no-margin"
                        :min="1"
                        :max="totalPages"
                        input
                    />
                </div>
            </div>
        </div>
        <q-inner-loading :visible="loading">
            <q-spinner size="75px" color="primary" />
        </q-inner-loading>
    </section>
</template>

<script>
/* eslint-disable */
import LinsSummary from './LinsSummary'
import MixinMessages from "@/mixins/mixinMessagens";

export default {
    name: 'q-lins-drf-table',

    mixins: [MixinMessages],

    props: {
        id: {
            type: String,
            default: 'tab'
        },

        afterRefresh: {
            type: Function
        },

        afterSort: {
            type: Function
        },

        autoLoad: {
            type: Boolean,
            default: true
        },

        beforeRefresh: {
            type: Function | Object
        },

        columns: {
            type: Array,
            default: function () {
                return [
                    {
                        align: { type: String },
                        classes: null,
                        cellClass: null,
                        decimal: { type: Number , default: -1 },
                        field: { type: String },
                        format: { type: Function },
                        headerClass: null,
                        maxWidth: { type: String },
                        hint: { type: String },
                        label: { type: String },
                        summary: { type: Boolean },
                        summaryClass: null,
                        onGetSummary: { type: Function },
                        sort: { type: Boolean, default: false },
                        sortField: { type: String }
                    }
                ]
            },
            required: true
        },

        dataTable: {
            type: Array,
            default: function () {
                return []
            }
        },

        defaultSort: {
            type: Object
        },

        disableSelectMsg: {
            type: String,
            default: ''
        },

        expand: {
            type: Boolean,
            default: false
        },

        keyField: {
            type: String
        },

        maxHeight: {
            type: String,
            default: null
        },

        onCellClick: {
            type: Function
        },

        onCellDblClick: {
            type: Function
        },

        pageSizes: {
            type: Array,
            default: () => [5, 10, 20, 30, 40, 50, 100]
        },

        pagination: {
            type: Boolean,
            default: true
        },

        selection: {
            type: String,
            default: '',
            validator: function (value) {
                return value === '' || value === 'single' || value === 'multiple' || value === 'summary' || value === 'summaryAll'
            }
        },

        selectAll: {
            type: Boolean,
            default: false
        },

        selectableRow: {
            type: Function
        },

        showSummary: {
            type: Boolean,
            default: false
        },

        onSortData: {
            type: Function
        },

        summaryLabel: {
            type: String,
            default: ''
        },

        onSelectRow: {
            type: Function
        },

        title: {
            type: String,
            default: ''
        },

        url: {
            type: String
        },

        userInterface: {
            type: String,
            default: ''
        },

        headerTotalPage: {
            type: String,
            default: 'x-total'
        },

        showRecordCount: {
            type: Boolean,
            default: false
        },

        headerNamePage: {
            type: String,
            default: 'page'
        },

        headerNamePerPage: {
            type: String,
            default: 'per_page'
        },

        showCopyButton: {
            type: Boolean,
            default: false
        },

        copyField: {
            type: String,
            default: 'id'
        },

        copyMessage: {
            type: String,
            default: 'Copiar'
        }
    },

    data () {
        return {
            apiData: [],
            clear: false,
            columnSort: null,
            defaultPerPage: 10,
            isMobile: false,
            lowResolution: true,
            lastConfig: null,
            loading: false,
            page: 1,
            pageSizesOptions: [],
            row: null,
            selectedObj: null,
            selectedRow: null,
            selectedRows: [],
            sort: null,
            totalPages: 0,
            totalRows: 0,
            summary: new LinsSummary()
        }
    },

    computed: {
        allSelected: {
            get(){
                return this.data.length > 0 && this.data.some(row => {
                    return this.checkedRow(row)
                }) && this.data.every(row => {
                    return this.checkedRow(row) || !this.$_doSelectableRow(row)
                })
            },

            set(value){
                this.checkAllInPage(value)
            }
        },

        countColumnsNoWidth: {
            get() {
                let count = 0
                if (Array.isArray(this.columns)) {
                    this.columns.forEach(col => {
                        count += col.width ? 0 : 1
                    })
                }
                return count
            }
        },

        columnSortDefault: {
            get() {
                let store = this.getLocalStore
                return store && store.sortBy ? store.sortBy : this.defaultSort
            },

            set(value) {
                if (this.userInterface){
                    this.$localStore.commit('setUserInterface', {
                        prop: this.userInterface.toLowerCase() + '.sortBy',
                        valor: value
                    })
                }
            }
        },

        data: {
            get() {
                return this.dataTable && this.dataTable.length > 0 ? this.dataTable : this.apiData
            }
        },

        getLocalStore() {
            return this.userInterface ? this.$localStore.state.userInterface[this.userInterface.toLowerCase()] : null
        },

        perPage: {
            get(){
                let store = this.getLocalStore
                return store && store.perPage ? store.perPage : this.defaultPerPage
            },

            set(value){
                if (this.userInterface){
                    this.$localStore.commit('setUserInterface', {
                        prop: this.userInterface.toLowerCase() + '.perPage',
                        valor: value
                    })
                    if (!this.loading) {
                        this.loading = true
                        this.page = 1
                        this.$_refresh()
                    }
                } else {
                    this.defaultPerPage = value
                    if (!this.loading) {
                        this.page = 1
                        this.$_refresh()
                    }
                }
            }
        },

        $_getHintClear() {
            if (this.selection === 'single') {
                return 'Limpa a seleção atual'
            }

            let unico = this.selectedRows.length === 1
            let aux = unico ? ' ' : 's '
            return 'Limpa o' + aux + (unico ? '' : this.selectedRows.length) + ' item' + aux + 'selecionado' + aux
        }
    },

    mounted() {
        // monta o sort esperado pelo django
        this.sort = this.$_getDrfSort(this.columnSortDefault)
        this.isMobile = this.$q.platform.is.mobile
        this.$_clearSummary()
        this.$_loadPageSize()
        if (this.autoLoad) {
            this.$_refresh()
        }
    },

    watch: {
        clear: function (value) {
            if (!value) {
                this.uncheckAll()
            }
        },

        page: function () {
            if (!this.loading) {
                this.$_refresh()
            }
        },

        pageSizes: function () {
            this.$_loadPageSize()
        },

        selectedRows: function (value) {
            if ('multiple summary'.match(this.selection)) {
                this.clear = value.length > 0
                if (typeof this.onSelectRow === 'function') {
                    this.onSelectRow(value)
                }
            }
        },

        selectedRow: function (value) {
            if (this.selection === 'single') {
                this.clear = value != null
                this.$_updateSelectedObj(value)
                if (typeof this.onSelectRow === 'function') {
                    this.onSelectRow(value, this.selectedObj)
                }
            }
        },

        selection: function () {
            this.uncheckAll()
        }
    },

    methods: {
        checkAllInPage(check) {
            this.data.forEach(row => {
                if (check) {
                    if (!this.checkedRow(row)){
                        if (this.$_doSelectableRow(row)) {
                            this.$_doSelectRow(row)
                        }
                    }
                } else {
                    if (this.checkedRow(row)){
                        this.$_doSelectRow(row)
                    }
                }
            })
        },

        checkedRow(row) {
            if (this.selection === 'single') {
                return this.selectedRow === row[this.keyField ? this.keyField : 'id']
            }
            return (this.selectedRows.indexOf(row[this.keyField ? this.keyField : 'id']) > -1)
        },

        $_clearSummary() {
            this.summary.clearValues()
            this.columns.forEach(col => {
                if (col.summary) {
                    document.getElementById('s-' + col.label).innerHTML = '0'
                }
            })
        },

        $_clickCheckBox(row) {
            this.$_updateSummary(row)
        },

        $_doAfterRefresh(data) {
            if (!this.pagination && this.columnSortDefault) {
                this.columnSort = this.columnSortDefault
                this.$_sortLoadedData(this.columnSortDefault)
            }
            if (typeof this.afterRefresh === 'function') {
                this.afterRefresh(data)
            }
        },

        $_doAfterSort(objSort) {
            this.columnSortDefault = objSort
            if (typeof this.afterSort === 'function') {
                this.afterSort(objSort)
            }
        },

        $_doCellClick(row, col) {
            if (typeof this.onCellClick === 'function') {
                this.onCellClick(row, col, row[col.field])
            } else {
                if (this.$_doSelectableRow(row)) {
                    this.$_doSelectRow(row, col)
                }
            }
        },

        $_doCellDblClick(row, col) {
            if (typeof this.onCellDblClick === 'function') {
                this.onCellDblClick(row, col, row[col.field])
            }
        },

        $_doFormatValue(row, col, field) {
            if (col && col.format && (typeof col.format === 'function')) {
                return col.format(row[field], row)
            }

            if (col.decimal > -1) {
                return parseFloat(!row[field] ? 0 : row[field]).toFixed(col.decimal)
            }
            return row[field]
        },

        $_doGetSummary(col) {
            let value = ''
            if ((this.selection === 'summary' || this.selection === 'summaryAll') && col.summary) {
                value = this.summary.sumColumn(col.label)
            }

            if (typeof col.onGetSummary === 'function') {
                return col.onGetSummary(this.data, value)
            }
            return value
        },

        $_doSelectRow(row){
            if (this.selection !== '') {
                let keyValue = row[this.keyField ? this.keyField : 'id']
                if (this.selection === 'single') {
                    this.selectedRow = keyValue
                } else {
                    let index = this.selectedRows.indexOf(keyValue)
                    index > -1 ? this.selectedRows.splice(index, 1) : this.selectedRows.push(keyValue)
                    this.$_updateSummary(row)
                }
            }
        },

        $_doSelectableRow(row) {
            if (typeof this.selectableRow === 'function') {
                return this.selectableRow(row)
            }
            return true
        },

        $_formatCellClass(row, col) {
            let cellClass = typeof col.cellClass === 'function' ? col.cellClass(row, col, row[col.field]) : col.celClass ? col.celClass : ''
            return cellClass + ' ' + this.$_formatColClass(col)
        },

        $_formatColClass(col) {
            return typeof col.classes === 'function' ? col.classes(col) : col.classes ? col.classes : ''
        },

        $_formatHeaderClass(col) {
            let headerClass = typeof col.headerClass === 'function' ? col.headerClass(col) : col.headerClass ? col.headerClass : ''
            return headerClass + ' ' + this.$_formatColClass(col)
        },

        $_formatSummaryClass(col, value) {
            let summaryClass = typeof col.summaryClass === 'function' ? col.summaryClass(col, value) : col.summaryClass ? col.summaryClass : ''
            return summaryClass + ' ' + this.$_formatColClass(col)
        },

        $_getColAlign(col) {
            return col.align ? col.align : 'left'
        },

        $_getColumn(fieldName){
            let col = null
            this.columns.some((value) => {
                col = (value.field === fieldName) || (value.sortField === fieldName) ? value : null
                return col != null
            })
            return col
        },

        $_getColWidth(col, maxWidth) {
            if (maxWidth) {
                return maxWidth
            }
            return col.width ? col.width : ((100 / this.countColumnsNoWidth) + '%')
        },

        $_getConfig() {
            if (this.page < 2 || !this.lastConfig) {
                let config = { params: {} }

                config.params[this.headerNamePage] = this.page
                config.params[this.headerNamePerPage] = this.perPage
                
                if (this.sort) {
                    config.params.sort = this.sort
                }
                return config
            }
            this.lastConfig.params[this.headerNamePage] = this.page
            this.lastConfig.params[this.headerNamePerPage] = this.perPage
            return this.lastConfig
        },

        $_getDrfSort(column) {
            let item = ''
            if (column && column.column !== null) {
                if (column.order === 'descending') {
                    item = '-'
                }
                item += column.prop
            }
            return item
        },

        $_getIconSort(col) {
            let colSort = this.columnSort
            if (colSort && ((colSort.prop === col.field) || (colSort.prop === col.sortField))) {
                return this.columnSort.order === 'descending' ? 'arrow_downward' : 'arrow_upward'
            }
            return 'import_export'
        },

        $_loadPageSize() {
            let options = []
            this.pageSizes.forEach(element => {
                options.push({
                    label: element + '/página',
                    value: element
                })
            })
            this.pageSizesOptions = options
        },

        $_onExpandClick(row) {
            row.expand = row.jaClicou ? row.expand : true
            if (row.expand && !row.jaClicou) {
                row.jaClicou = true
                this.$emit('expandRow', row)
            }
        },

        $_onResize() {
            this.lowResolution = (document.documentElement.clientWidth < 601)
        },

        recordCount(inDisplay = false) {
            return inDisplay ? this.data.length : this.totalRows
        },

        $_refresh() {
            this.loading = true
            try {
                // configuração básica
                let config = this.$_getConfig()
                // configuração adicional via before request
                if ((typeof this.beforeRefresh === 'function') && (this.page < 2)) {
                    config = this.beforeRefresh(config, this.row)
                }
                this.lastConfig = config

                if (config) {
                    this.$http.get(this.url, config)
                        .then(response => {
                            let recordCount = response.headers[this.headerTotalPage]
                            if (this.pagination || !recordCount || (Number(recordCount) <= Number(this.perPage))) {
                                if (response.data instanceof Array){
                                    this.apiData = response.data
                                } else {
                                    this.apiData = [response.data]
                                }
                                this.$_setTotalPages(recordCount)
                                this.$_doAfterRefresh(this.apiData, response.headers)
                                this.loading = false
                            } else {
                                this.perPage = recordCount
                                this.$_refresh()
                            }
                        })
                        .catch((erro) => {
                            console.log(erro)
                            this.errorMessage({
                                title: 'Erro ao carregar os dados',
                                message: 'Verifique a disponibilidade do serviço',
                                apiError: erro
                            })
                            this.loading = false
                        })
                } else {
                    this.errorMessage({
                        title: 'Erro ao carregar os dados',
                        message: 'Configuração inválida',
                        duration: 0
                    })
                    this.loading = false
                }
            } catch (error) {
                console.log(error)
                this.loading = false
                this.errorMessage({
                    title: 'Erro ao carregar os dados',
                    message: error,
                    duration: 0
                })
            }
        },

        search(row){
            this.uncheckAll()
            this.columnSort = this.columnSortDefault
            this.sort = this.$_getDrfSort(this.columnSortDefault)
            this.loading = true
            this.page = 1
            this.row = row
            this.$_refresh()
        },

        selected() {
            return this.selection === 'single' ? this.selectedRow : this.selectedRows
        },

        selectedObjs() {
            if (this.selection === 'single') {
                return this.selectedObj
            } else {
                //Necessário loadfull na tabela para utilizar este método
                let objs = []
                let listObjs = this.selection === 'single' ? [this.selectedRow] : this.selectedRows

                if (listObjs.length > 0 && listObjs[0] !== null) {
                    this.data.forEach(row => {
                        if (listObjs.indexOf(row.id) > -1) {
                            objs.push(row)
                        }
                    })
                }
                return objs
            }
        },

        $_setTotalPages(totalRegistros) {
            let lPages = parseInt(totalRegistros)
            this.totalRows = lPages
            if (lPages > 0) {
                this.totalPages = parseInt(lPages / this.perPage)
                if (lPages % this.perPage !== 0) {
                    this.totalPages++
                }
            } else {
                this.totalPages = 0
            }
        },

        $_sortBy(col) {
            if (col.sort) {
                let sort = this.columnSort
                let sortField = col.sortField ? col.sortField : col.field
                let objSort = { prop: '', order: '' }
                let sameField = sort && (sort.prop === sortField)

                if (!sameField || (sort.order !== 'descending')) {
                    objSort.prop = sortField
                    objSort.order = sameField ? 'descending' : 'ascending'
                } else if (this.defaultSort && (this.defaultSort.prop !== sortField || this.defaultSort.order !== 'descending')) {
                    objSort = this.defaultSort
                }

                this.columnSort = objSort
                if (this.pagination || objSort.prop === '' || objSort === this.defaultSort) {
                    this.sortData(objSort)
                } else {
                    this.$_sortLoadedData(objSort, col)
                }
            }
        },

        sortData(objSort) {
            if (typeof this.onSortData === 'function') {
                this.onSortData(this.data, objSort)
            } else {
                this.sort = this.$_getDrfSort(objSort)
                this.page = 1
                this.$_refresh()
            }
            this.$_doAfterSort(objSort)
        },

        $_sortLoadedData(objSort, column) {
            if (objSort && objSort.prop){
                let col = column !== undefined ? column : this.$_getColumn(objSort.prop)
                if (col) {
                    this.data.sort((row, nextRow) => {
                        let index = 0
                        if (typeof col.sort === 'function') {
                            index = col.sort(row, nextRow)
                        } else {
                            let value = this.$_doFormatValue(row, col, col.field)
                            let nextValue = this.$_doFormatValue(nextRow, col, col.field)
                            index = value < nextValue ? -1 : value > nextValue ? 1 : 0
                        }
                        return objSort.order === 'ascending' ? index : -1 * index
                    })
                    this.$_doAfterSort(objSort)
                }
            }
        },

        uncheckAll() {
            this.selectedRows = []
            this.selectedRow = null
            if (this.selection === 'summary') {
                this.$_clearSummary()
            }
        },

        $_updateSelectedObj(value) {
            let keyField = this.keyField ? this.keyField : 'id'
            this.selectedObj = null
            if (value && this.data) {
                this.data.some(row => {
                    if (row[keyField] === value) {
                        this.selectedObj = row
                        return this.selectedObjs
                    }
                })
            }
        },

        $_updateSummary(row) {
            if (this.selection === 'summary' || this.selection === 'summaryAll') {
                let checked = this.checkedRow(row)
                let key = row[this.keyField ? this.keyField : 'id']

                this.columns.forEach(col => {
                    if (col.summary) {
                        checked ? this.summary.addValue(col.label, key, this.$_doFormatValue(row, col, col.field)) : this.summary.delValue(col.label, key)
                        document.getElementById('s-' + col.label).innerHTML = this.$_doGetSummary(col)
                    }
                })
            }
        },

        $_copyCellData(row) {
            this.notificacao({title: "Copiado", message: "Codigo copiado para área de transferência"})
            navigator.clipboard.writeText(row[this.copyField])
        }
    }
}
</script>

<style lang="scss" scoped>
.q-lins-drftable-container {
    font-family: Arial, "-apple-system", "Helvetica Neue", Helvetica, sans-serif;
    width: 100%;

    .c-lins-table-container {
        width: inherit;
        height: auto;
        min-height: inherit;
        overflow-y: hidden;
        overflow-x: auto;

        .c-lins-table {
            width: inherit;
            height: inherit;
            min-height: inherit;
            tbody {
                overflow-x: hidden;
                display: block;
            }
            thead {
                display: block;
            }
            tfoot {
                display: block;
                border-color: inherit;
                .c-table-summary {
                    font-weight: bold;
                }
            }
        }
    }

    .c-lins-table-font {
        font-size: 13px !important;
    }

    .c-pagination-container {
        width: 100%
    }

    .pagination {
        margin-left: 30px;
    }

    .c-lins-table-col-select {
        width: 30px;
        min-width: 30px;
        max-width: 30px;
        padding: 5px !important;
        text-align: center;
        height: 31px;
        min-height: 31px;
    }

    .c-lins-table-col-expand {
        width: 40px;
        min-width: 40px;
        max-width: 40px;
        padding: 5px 10px !important;
        text-align: center;
        height: 31px;
        min-height: 31px;
    }

    .c-lins-table-col-copy {
        width: 40px;
        min-width: 40px;
        max-width: 40px;
        padding: 5px 1px !important;
        text-align: center;
        align-items: center;
        height: 31px;
        min-height: 31px;
    }

    .th-select{
        color: #7A24B9 !important;
        text-align: center;
        .c-check-header{
            .q-checkbox-checked {
                font-size: 17px !important;
            }
        }
        :hover {
            background-color: #7b24b98c;
            color: white;
        }
    }

    .c-col-label {
        white-space: nowrap;
        font-weight: 700
    }

    // .c-lins-table-row {
    //     width: auto !important
    // }

    .c-lins-table-row-expand {
        padding-bottom: 15px !important;
    }

    .c-table-col {
        overflow: hidden;
        overflow-x: hidden;
        overflow-y: hidden;
        height: 30px;
        min-height: 30px;
        padding: 5px !important;
        color: rgba(0, 0, 0, 0.54);
        border-bottom: solid 2px rgba(50, 49, 51, 0.288);
    }

    .c-lins-table-sel-pagination {
        .q-input-target {
            color: rgba(168, 154, 154, 0.746);
        }
    }

    tr:hover{
        color: #7b24b9ce;
    }

    .c-table-cell{
        overflow: hidden;
        overflow-x: hidden;
        overflow-y: hidden;
        padding: 5px !important;
        white-space: nowrap;
        height: 31px !important;
        min-height: 31px !important;
        // border-bottom: solid 1px rgba(50, 49, 51, 0.288);
    }

    .c-row-zebra {
        background-color: rgba(0, 0, 0, 0.07)
    }

    .q-lins-drf-table-message {
        font-style: normal;
        color: rgba(0, 0, 0, 0.54);
        display: flex;
    }
    .font-mobile {
        font-size: 1.2rem;
    }
    .q-table tbody td:before {
        background-color: transparent;
    }
}

</style>